import Vue from "vue";
import Vuex from "vuex";

import info from "@/data/info.js";
import sections from "@/data/sections.js";
import stops from "@/data/stops.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    stops: [],
    sections: [],
    info: {},
    currentStop: 1,
    playingNow: {
      id: 1
    },
    isPlaying: false,
    navOpen: false,
    playerShowing: false,
    currentLang: "en"
  },
  mutations: {
    SET_STOPS(state, stops) {
      state.stops = stops;
    },
    SET_INFO(state, info) {
      state.info = info;
    },
    SET_SECTIONS(state, sections) {
      state.sections = sections;
    },
    TOGGLE_NAV_MODAL(state) {
      state.navOpen = state.navOpen == false ? true : false;
    },
    TOGGLE_PLAYER_VISIBLE(state, status) {
      state.playerShowing = status;
    },
    TOGGLE_PLAYING(state, playingNow) {
      state.playingNow = playingNow;
    },
    TOGGLE_IS_PLAYING(state, isPlaying) {
      state.isPlaying = isPlaying;
    },
    UPDATE_LANGUAGE(state, lang) {
      state.currentLang = lang;
    },
    CURRENT_STOP(state, currentStop) {
      state.currentStop = currentStop;
    }
  },
  // call mutations which update state
  actions: {
    initialiseStops({ commit }) {
      commit("SET_STOPS", stops);
    },
    initialiseInfo({ commit }) {
      commit("SET_INFO", info);
    },
    initialiseSections({ commit }) {
      commit("SET_SECTIONS", sections);
    },
    toggleNavigation({ commit }) {
      commit("TOGGLE_NAV_MODAL");
    },
    togglePlayer({ commit }, status) {
      commit("TOGGLE_PLAYER_VISIBLE", status);
    },
    togglePlaying({ commit }, playing) {
      commit("TOGGLE_PLAYING", playing);
    },
    toggleIsPlaying({ commit }, isPlaying) {
      commit("TOGGLE_IS_PLAYING", isPlaying);
    },
    updateLanguage({ commit }, lang) {
      if (lang !== "auslan") {
        commit("UPDATE_LANGUAGE", lang);
        commit("UPDATE_PLAYER_MODE", "en");
        /* 
                    - Keep LANG as english
                    - But, use VIDEO instead of AUDIO 
                */
      } else {
        commit("UPDATE_LANGUAGE", "en");
        commit("UPDATE_PLAYER_MODE", "auslan");
      }
    },
    updateCurrentStop({ commit }, id) {
      commit("CURRENT_STOP", id);
    }
  },
  getters: {
    getStopFromId: state => id => {
      return state.stops.find(stop => stop.id === id);
    }
  }
});
